import React from 'react';


export default function FooterAURA(){
return (
<footer id="contacto" className="py-5 text-center text-muted">
<div className="container">
<p>© {new Date().getFullYear()} AURA — Aromas que cuentan tu historia</p>
</div>
</footer>
)
}